export { CampaignCommunicationType } from './generated/CampaignCommunicationType.js';